import { FC, ReactNode } from 'react';

/**
 * RenderIf Component - Render a component if isTrue is true
 * @param isTrue - boolean
 * @param children - ReactNode
 */
export const RenderIf: FC<{ isTrue: boolean; children: ReactNode }> = ({
  isTrue,
  children,
}) => {
  return isTrue ? <>{children}</> : null;
};
